// extracted by mini-css-extract-plugin
export default {"root":"toppingsButton-module__root--FbZ9q"};